import { render, staticRenderFns } from "./AddPupil.vue?vue&type=template&id=f99c6abc&scoped=true&"
import script from "./AddPupil.vue?vue&type=script&lang=js&"
export * from "./AddPupil.vue?vue&type=script&lang=js&"
import style0 from "./AddPupil.vue?vue&type=style&index=0&id=f99c6abc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99c6abc",
  null
  
)

export default component.exports